export const VEHICLE_PHOTO_PLACEHOLDER = "/pictures/vehicle-photo-placeholder.png";
export const VEHICLE_PHOTO_PLACEHOLDER_ALT = "Фото скоро будет добавлено";

export function getVehicleImageLinks(imageLinks) {
    return Array.isArray(imageLinks)
        ? imageLinks.filter((link) => typeof link === "string" && link.trim())
        : [];
}
